import styled from 'styled-components';
import * as Popover from '@radix-ui/react-popover';

export const AnchoredPopoverWrapper = styled(Popover.Content)<{ $maxWidth?: number | string; $zIndex?: number }>`
    max-width: ${p => (typeof p.$maxWidth === 'number' ? `${p.$maxWidth}px` : p.$maxWidth) ?? '336px'};
    border-radius: ${p => p.theme.message.base.borderRadius};
    overflow: visible;
    z-index: ${p => p.$zIndex ?? 998};
    background: ${p => p.theme.root.colors.system.infoDefault};
`;

export const AnchoredPopoverArrow = styled(Popover.Arrow)`
    display: block;
    fill: ${p => p.theme.root.colors.system.infoDefault};
    margin: 0;
`;
